import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddComponent } from './add/add.component';
import { EditComponent } from './edit/edit.component';
import { ListComponent } from './list/list.component';
import { ViewComponent } from './view/view.component';
import { CollegeReportComponent } from './college-report/college-report.component';
import { CompanyReportComponent } from './company-report/company-report.component';
import { ClientReportComponent } from './client-report/client-report.component';
import { ClientListComponent } from './client-list/client-list.component';
import { ClientAddComponent } from './client-add/client-add.component';
import { PermissionGuard } from 'app/shared/auth/auth-guard.service';

const routes: Routes = [
      {
        path:'list',component:ListComponent,
        canActivate: [PermissionGuard],
          data: { roles: ['admin','Managment','Sales','Training Moderator','Operation'] }
      },
      {
        path:'add',component:AddComponent
      },
      {
        path:'view/:id',component:ViewComponent
      },
      {
        path:'edit/:id',component:EditComponent
      },
      {
        path:'college-reports',component:CollegeReportComponent,
        canActivate: [PermissionGuard],
          data: { roles: ['admin','Managment','Training Moderator'] }
      },
      
      {
        path:'company-reports',component:CompanyReportComponent,
        canActivate: [PermissionGuard],
          data: { roles: ['admin','Managment','HR'] }
      },
       {
        path:'client-reports',component:ClientReportComponent,
        canActivate: [PermissionGuard],
          data: { roles: ['admin','Managment'] }
      },
      {
        path:'lists',component:ClientListComponent,
        canActivate: [PermissionGuard],
          data: { roles: ['admin','Managment','Sales'] }
      },
      {
        path:'add-client',component:ClientAddComponent
      },
      {
        path:'edit-client/:id',component:ClientAddComponent
      }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BusinessRoutingModule { }
